import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { getUserDetails } from 'store/entities/auth/thunks';
import { getUserInstitutions } from 'store/entities/institutions/thunks';

import useCurrentLanguage from 'utils/hooks/useCurrentLanguage';
import useUserRoles from 'utils/hooks/auth/useUserRoles';

import Header from 'components/Header';
import Router from 'components/Router';
import Footer from 'components/Footer';
import LandingPage from 'views/Landing';

import LoadingSpinner from 'components/UIComponents/LoadingSpinner';

import './App.scss';
import 'assets/scss/styles.scss';
import { useIsAuthenticated } from '../../utils/hooks/auth/useUserHasFullAuth';

const App = () => {
  const dispatch = useDispatch();
  const { userDetailsLoading } = useSelector(state => state.auth);
  const { userRoles, isMainUser, isReporter } = useUserRoles();
  const language = useCurrentLanguage();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (userRoles.length > 0) {
      if (isMainUser || isReporter) dispatch(getUserInstitutions());
    }
  }, [userRoles, isMainUser, isReporter, dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getUserDetails());
    }
  }, [isAuthenticated, dispatch]);

  return (
      <div className="datagate-external">
        <LoadingSpinner loading={userDetailsLoading} position="global" />
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <Header />
          <div role="main">
            {isAuthenticated ? (
                <Router />
            ) : (
                <Switch>
                  <Route exact path="/:lang" component={LandingPage} />
                  <Redirect from="*" to={`/${language}`} exact />
                </Switch>
            )}
          </div>
          <ToastContainer icon={false} />
          <Footer />
        </BrowserRouter>
      </div>
  );
};

export default App;
